// const slide = document.querySelector('.slick-slide');

// function updateTabindex() {
//     if (slide.classList.contains('slick-current')) {
//         slide.setAttribute('tabindex', '-1');
//     } else {
//         slide.removeAttribute('tabindex');
//     }
// }

// // Initial call to set tabindex on page load
// updateTabindex();

// // Use MutationObserver to detect class changes
// const observer = new MutationObserver(updateTabindex);

// // Observe changes to the class attribute
// observer.observe(slide, {
//     attributes: true,
//     attributeFilter: ['class']
// });

// Get the dot buttons
// setTimeout(() => {
//   const dotButtons = document.querySelectorAll('.slick-dots button');
//   console.log('buttonfound', dotButtons);
  
//   function stopAutoSlide() {
//       clearInterval(autoSlideInterval);
//   }
//   dotButtons.forEach(button => {
//       button.addEventListener('click', (event) => {
//           event.preventDefault();
//       });
//   });
//   stopAutoSlide();
// }, 1500);

//Skip to main content
function setFocus(event) {
    event.preventDefault();
      const mainContent = document.getElementById('main-content');
      mainContent.setAttribute('tabindex', '-1');
      mainContent.focus();
  mainContent.addEventListener('blur', () => {
        mainContent.removeAttribute('tabindex');
    }, { once: true });
}


// Pausing moving content
setTimeout(() => {
  const infiniteScrollElements = document.querySelectorAll('.infinite-scroll');

  setTimeout(() => {
      infiniteScrollElements.forEach(element => {
          element.style.animationPlayState = 'paused';
      });
  }, 7000);
}, 500);

//hiding heading
document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    var removeheading = document.querySelector('.recommended-products__title');
    
    if (removeheading) {
      removeheading.setAttribute('aria-hidden', 'true');
    }
  }, 1000);
});

//Proving grrouping to radio buttons
document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    var setgrouping = document.querySelector('.rc-template__radio');
    
    if (setgrouping) {
      setgrouping.setAttribute('role', 'radiogroup');
      setgrouping.setAttribute('aria-label', 'Purchase Type');
    }
  }, 1000);
});

//Providing title
document.addEventListener('DOMContentLoaded', () => {
  const urls = [
    'https://amaraorganicfoods.com/collections/all-products?page=1',
    'https://amaraorganicfoods.com/collections/all-products'
  ];

  if (urls.includes(window.location.href)) {
      fetch(window.location.href) // Fetch the current URL
          .then(response => {
              if (!response.ok) {
                  throw new Error('Network response was not ok');
              }
              return response.text();
          })
          .then(data => {
              document.title = "All Products Page 1 - Amara Organic Foods";
          })
          .catch(error => {
              console.error('There has been a problem with your fetch operation:', error);
          });
  }
});


document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    const customAriaElements = document.querySelectorAll('.custom_aria');
    customAriaElements.forEach((element) => {
      const anchor = element.querySelector('a');
      const heading = element.closest('.image-with-text__wrapper').querySelector('.image-with-text__heading');

      if (anchor && heading) {
        const headingText = heading.innerText;
        const linkText = anchor.innerText;
        anchor.setAttribute('aria-label', `${headingText} - ${linkText}`);
      }
    });
  }, 1000);
});

//Dailog focus
document.addEventListener('DOMContentLoaded', function () {
  var setModalLink = document.getElementById('closemodalsearch');

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      const headerLink = document.querySelector('.header__link.is-active');
      const actionAreaLink = document.querySelector('.action-area__link.is-active');
      if (headerLink || actionAreaLink) {
      }
      const closeButton = document.querySelector('.fancybox-close-small');
      if (mutation.type === 'childList' && closeButton) {
        if (!closeButton.dataset.listenerAdded) {
          closeButton.setAttribute('aria-label', 'Close');
          closeButton.addEventListener('click', function () {
            if (setModalLink) {
              setModalLink.focus();
            }
          });
          closeButton.dataset.listenerAdded = true;
        }
      }
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
});


document.addEventListener('DOMContentLoaded', function() {
  const checkboxes = document.querySelectorAll('[data-tag-filter-checkbox]');

  checkboxes.forEach(checkbox => {
    checkbox.addEventListener('focus', function() {
      const label = document.querySelector(`label[for="${this.id}"]`);
      if (label) {
        label.classList.add('focus'); // Add a class for visual indication, if needed
        label.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    });

    checkbox.addEventListener('blur', function() {
      const label = document.querySelector(`label[for="${this.id}"]`);
      if (label) {
        label.classList.remove('focus'); // Remove the class when not focused
      }
    });
    // checkbox.addEventListener('keydown', function(e) {
    //   if(e.)
    // });
  });

// const textWrapper = document.querySelector('.image-with-text__text');

// const ul = document.createElement('ul');
// ul.classList.add('customize-for-baby');
// ul.style.listStyle = 'none';
// ul.style.marginLeft = '0';
// ul.style.marginTop = '0';
// const paragraphs = textWrapper.querySelectorAll('p');

// paragraphs.forEach(paragraph => {
//     const li = document.createElement('li');
//     li.textContent = paragraph.textContent;
//     ul.appendChild(li);
// });
// textWrapper.innerHTML = '';
// textWrapper.appendChild(ul);

});


//Review fields mandatory
function reviewRatings(){
  const ratings = document.querySelectorAll('.jdgm-prev-badge__stars');
  if(ratings) {
    ratings.forEach(rating => {
      // console.log('Review ratings');
      rating.setAttribute('role', 'img');
      rating.removeAttribute('tabindex');
      const ratingLabel = rating.getAttribute('aria-label');
      rating.setAttribute('aria-label', ratingLabel + ' out of 5');
    });
  }

}

//Calling functions on complete page load
window.addEventListener('load', function() {
  reviewRatings();
  menuButtonEvent();
  closeEsc();
  learnMenu();
  setAltFromLinkText();
  toggleOverlayOnTab();
  toggleOverlayOnShiftTab();
  // scrollToButtonOnFocus();
  focusOnNewsLetterSignUp();
  // pToq();
});

// document.addEventListener('DOMContentLoaded', function() {
//   menuButtonEvent();
// });

//Menu button events
function menuButtonEvent(){
  console.log('hello');
  // const menuButton = document.querySelectorAll('.has-dropdown button.expandMenu');
  const megaMenuButton = document.querySelector('li.has-mega-menu button.expandMenu');
  // const mainMenu = document.querySelector('li.has-mega-menu');
  if(megaMenuButton) {
  megaMenuButton.addEventListener('click', function() {
    console.log("Not getting it");
    const isExpanded = this.getAttribute('aria-expanded') === 'true';

    // Toggle aria-expanded attribute
    this.setAttribute('aria-expanded', !isExpanded);

    const section = document.querySelector('li.has-mega-menu section');

    // Toggle the is-active class based on the aria-expanded value
    if (!isExpanded) {
        section.classList.add('is-active');
    } else {
        section.classList.remove('is-active');
    }
    
  });
  }
  // menuButton.forEach(button => {
  //   button.addEventListener('click', function(e) {
  //     const menuLi = button.closest('li');
  //     const isExpanded = button.getAttribute('aria-expanded') === "true";
  //     if (isExpanded) {
  //       console.log('expanded');
  //       button.setAttribute('aria-expanded', 'false');
  //     }
  //     else {
  //       console.log('not expanded');
  //       button.setAttribute('aria-expanded', 'true');
  //     }
  //   });
  // });
}

function learnMenu() {
  // li.has-dropdown[data-navlink-handle="learn"] button
  const learnButton = document.querySelector('li.has-dropdown[data-navlink-handle="learn"] button');
  const learnLink = document.querySelector('li.has-dropdown[data-navlink-handle="learn"] label');
  learnLink.setAttribute('aria-hidden', 'true');

  learnButton.addEventListener('click', function() {
    const isExpanded = this.getAttribute('aria-expanded') === 'true';

    // Toggle aria-expanded attribute
    this.setAttribute('aria-expanded', !isExpanded);

    const section = document.querySelector('li.has-dropdown[data-navlink-handle="learn"] .navbar-dropdown');

    // Toggle the is-active class based on the aria-expanded value
    if (!isExpanded) {
        section.classList.add('is-expanded');
    } else {
        section.classList.remove('is-expanded');
    }
    
  });
}
function closeEsc() {
  const sectionMega = document.querySelector('li.has-mega-menu section');
  const learnMega = document.querySelector('li.has-dropdown[data-navlink-handle="learn"] .navbar-dropdown');
  const learnButton = document.querySelector('li.has-dropdown[data-navlink-handle="learn"] button');
  const megaMenuButton = document.querySelector('li.has-mega-menu button.expandMenu');
  if(sectionMega) {
  sectionMega.addEventListener('keydown', function(e) {
    if(e.keyCode == 27) {
      sectionMega.classList.remove('is-active');
      megaMenuButton.setAttribute('aria-expanded', 'false');
      setTimeout(() => {
        megaMenuButton.focus();
      }, 50);
    }
  });
  }
  if(learnMega) {
  learnMega.addEventListener('keydown', function(e) {
    if(e.keyCode == 27) {
      learnMega.classList.remove('is-expanded');
      learnButton.setAttribute('aria-expanded', 'false');
      setTimeout(() => {
        learnButton.focus();
      }, 50);
    }
  });
  }
}

// function pToq() {
//   const paragraphs = document.querySelectorAll('.jdgm-rev__content .jdgm-rev__body p');

//   console.log('hello quote');
//   // Function to convert <p> to <q>
//   paragraphs.forEach((p) => {
//     const q = document.createElement('q');  // Create a new <q> element
//     q.innerHTML = p.innerHTML;              // Copy the content from <p> to <q>
//     // Replace the <p> with the new <q> element
//     p.parentNode.replaceChild(q, p);
//     });
// 

//Setting alt to the image link of the products
function setAltFromLinkText() {
  // Select all elements with class "product-wrap"
  const productWrappers = document.querySelectorAll('.product-wrap');

  productWrappers.forEach(wrapper => {
    // Find the link with class "thumbnail_caption" within the product wrapper
    const link = wrapper.querySelector('.thumbnail__caption a');
    // Find the image within the product wrapper
    const img = wrapper.querySelector('img');

    // Check if both link and image are present
    if (link && img) {
      // Set the alt attribute of the image to the text of the link
      img.alt = link.textContent.trim();
    }
  });
}

//To show quickview with keyboard
function toggleOverlayOnTab() {
  // Select all elements with class "product__imageContainer"
  const imageLinks = document.querySelectorAll('.product-wrap .product__imageContainer');

  imageLinks.forEach(link => {
    // Add a keydown event listener on each link
    link.addEventListener('keydown', function(event) {
      // Check if the key pressed is "Tab"
      if (event.key === 'Tab' && !event.shiftKey) {
        // Find the overlay container within the same product-wrap
        const overlayContainer = link.closest('.product-wrap').querySelector('.thumbnail-overlay__container');
        
        // Check if the overlay container exists
        if (overlayContainer) {
          // Set display to block
          overlayContainer.style.display = 'flex';
        }
      }
      // Check if the key pressed is the Down Arrow
      // if (event.key === 'ArrowDown') {
      //   // Find the overlay container within the same product-wrap
      //   const overlayContainer = link.closest('.product-wrap').querySelector('.thumbnail-overlay__container');
        
      //   // Check if the overlay container exists
      //   if (overlayContainer) {
      //     // Set display to flex
      //     overlayContainer.style.display = 'flex';
      //   }
      // }
    });
  });

  // Select all buttons inside the thumbnail-overlay__container
  const overlayButtons = document.querySelectorAll('.thumbnail-overlay__container button');

  overlayButtons.forEach(button => {
    // Add a keydown event listener on each button
    button.addEventListener('keydown', function(event) {
      // Check if the key pressed is "Tab"
      if (event.key === 'Tab') {
        // Find the overlay container for the current button
        const overlayContainer = button.closest('.thumbnail-overlay__container');
        
        // Check if the overlay container exists
        if (overlayContainer) {
          // Set display to none
          overlayContainer.style.display = '';
        }
      }
    });
  });
}

function toggleOverlayOnShiftTab(){
  // .product-wrap .buttons .button--primary
  // Select all elements with class "product__imageContainer"
  const productBtns = document.querySelectorAll('.product-wrap .buttons .button--primary');

  productBtns.forEach(prodBtn => {
    // Add a keydown event listener on each button
    prodBtn.addEventListener('keydown', function(event) {
      // Check if the key pressed is "Shift + Tab"
      if (event.key === 'Tab' && event.shiftKey) {
        // Find the overlay container within the same product-wrap
        const overlayContainer = prodBtn.closest('.product-wrap').querySelector('.thumbnail-overlay__container');
        
        // Check if the overlay container exists
        if (overlayContainer) {
          // Set display to block
          overlayContainer.style.display = 'flex';
        }
      }
    });
  });
}


function focusOnNewsLetterSignUp(){
  const statusMsg = document.querySelector('.newsletter-form--newsletter-section .quote');

  if(statusMsg){
    statusMsg.setAttribute('tabindex', '-1');
    statusMsg.focus();
  }
}
//Focus back to triggering element
document.addEventListener('DOMContentLoaded', function() {
  let quickviewtrigger = null;
  
  const quickViewButtons = document.querySelectorAll('.js-quick-shop-link');
  // console.log('quickviewbuttons', quickViewButtons);
  
  quickViewButtons.forEach(button => {
    button.addEventListener('click', function(event) {
      // console.log('test');
      quickviewtrigger = event.target; 
      // console.log('hetasd', quickviewtrigger);
    });
  });
  
  const observer = new MutationObserver(function(mutationsList) {
    for (let mutation of mutationsList) {
      if (mutation.type === 'childList') {
        const modal = document.querySelector('.fancybox-container');
        
        if (modal) {  // Check if modal is not null
          // console.log('qw543qw4e', modal);
  
          if (!modal.hasAttribute('data-listener-attached')) {
            const closeModalButton = modal.querySelector('.fancybox-close-small');
            // console.log('close found', closeModalButton);
            
            if (closeModalButton) {
              closeModalButton.addEventListener('click', function() {
                modal.style.display = 'none';
                modal.classList.remove('fancybox-is-open');
  
                if (quickviewtrigger) {
                  quickviewtrigger.focus();
                }
              });
  
              modal.setAttribute('data-listener-attached', 'true');
            }
          }
        }
      }
    }
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});







